import * as cn from "./FinanceReport.scss"
import {User} from "./../model/User"
import {FinanceSummaryRow, yearColumns} from "./Final"
import {getCompany, getUniversityBranch} from "../model/utils/utils";
import {Divisions} from "../model/Division";
import {UniversityBranch, UniversityBranches} from "../model/UniversityBranch";
import * as React from "react";
import {Finance, SpendingType, spendingTypeTitle} from "../model/Finance";
import {Footer} from "./Footer";


type Props = {
    finances: Finance[]
    divisions: Divisions
    universityBranches: UniversityBranches
    user: User
    company: string
    total: FinanceSummaryRow
    order: number
}

type RowProps = {
    final: number
    forecast: number
    spendingType: SpendingType
    cooperationSubject: string
    universityBranch: UniversityBranch
    company: {
        company: string
    }
}

export class Row extends React.PureComponent<RowProps> {
    render() {
        const {
            final,
            forecast,
            spendingType,
            cooperationSubject,
            universityBranch: {
                abbreviation: university,
            },
            company: {
                company,
            },
        } = this.props

        return (
            <tr className = {cn.row}>
                <td className = {cn.cell}>{company}</td>
                <td className = {cn.cell}>{university}</td>
                <td className = {cn.cell}>{spendingTypeTitle[spendingType]}</td>
                <td className = {cn.cell}>{final}</td>
                <td className = {cn.cell}>{forecast}</td>
                <td className = {cn.cell}>{cooperationSubject}</td>
            </tr>
        )
    }
}

export class FinanceReport extends React.PureComponent<Props> {
    render() {
        const {finances, company, user, divisions, universityBranches, total, order} = this.props

        return (
            <div className = {cn.component}>
                <div className = {cn.page}>
                    <br/>
                    <div className = {cn.heading}>
                        <div className = {cn.title}>
                            Данные о расходовании средств на взаимодействие с образовательными организациями
                            <br/>
                            организацией Госкорпорации «Росатом»
                            <br/>
                            Приложение № {order}
                        </div>
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Организация:</div><div className = {cn.value}>{company}</div>
                        </div>
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Дата заполнения:</div>
                            <div className = {cn.value}>
                                {("0" + new Date().getDate()).slice(-2) + "." + ("0"+(new Date().getMonth()+1)).slice(-2) + "." + new Date().getFullYear()}
                            </div>
                        </div>
{/*
                        <div className = {cn.meta}>
                            <div className = {cn.label}>Ответственный:</div><div className = {cn.value}>{user.executor.fullName}</div>
                        </div>
*/}
                    </div>
                    <br/>
                    <br/>
                    <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                        <colgroup>
                            {Array.apply(null, Array(6)).map((value, key) => <col {...{key}} className = {cn.column}/>)}
                        </colgroup>
                        <thead className = {cn.head}>
                        <tr className = {cn.headRow}>
                            <td className = {cn.headCell} rowSpan = {2}>Организация ГК «Росатом»</td>
                            <td className = {cn.headCell} rowSpan = {2}>Образовательная организация</td>
                            <td className = {cn.headCell} rowSpan = {2}>Направление расходования средств</td>
                            <td className = {cn.headCell} colSpan = {2}>Сумма финансирования</td>
                            <td className = {cn.headCell} rowSpan = {2}>Предмет сотрудничества с образовательной организацией</td>
                        </tr>
                        <tr className = {cn.headRow}>
                            <td className = {cn.headCell}>Отчетный год (факт)</td>
                            <td className = {cn.headCell}>Год, следующий за отчетным (план)</td>
                        </tr>
                        </thead>
                        <tbody>
                        {finances.map((finance: Finance) => {
                            return <Row {...{
                                key: finance.id,
                                final: finance.yearFinal,
                                forecast: finance.yearForecast,
                                company: getCompany(divisions, finance.companyId),
                                universityBranch: getUniversityBranch(universityBranches, finance.universityBranchId),
                                cooperationSubject: finance.cooperationSubject,
                                spendingType: finance.spendingType,
                            }}/>
                        })}
                        <tr className = {cn.rowTotal}>
                            <td className = {cn.cellTotal} colSpan={3}>Итого:</td>
                            <td className = {cn.cellTotal}>{total.final || ""}</td>
                            <td className = {cn.cellTotal}>{total.forecast || ""}</td>
                            <td className = {cn.cellTotal}/>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <Footer user={user}/>
            </div>
        )
    }
}